export default __webpack_public_path__ + "express.ee39e7fe.png";